import script from "./SubscriptionPlanNote.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionPlanNote.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlanNote.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionPlanNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanNote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cc69b9f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cc69b9f8', __exports__)) {
    api.reload('cc69b9f8', __exports__)
  }
  
}


export default __exports__